module.exports = __webpack_public_path__ + "img/news_cateory.abd00e7b.png";